export const visit = (vm, at) => {
at({ "pt-br": { "conversationsVisitorUIAvailability": { "sameDay": "Retornaremos hoje \xE0s {{time}}", "nextDay": "Retornaremos amanh\xE3 \xE0s {{time}}", "nextWeek": "Retornaremos {{dayOfWeek}} \xE0s {{time}}" } } });
};